<template>
  <div class="wrapper">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <h4>Logging In...</h4>
    </div>
    <Toast />
    <Dialog header="Two-Factor Verification" :visible.sync="showCodeVerification" :modal="true" 
    :style="{ width: '500px !important' }" :closable="true" @hide="resetForm">
      <div class="p-d-flex p-flex-column p-ai-center p-p-4">
        <p class="p-text-center p-mb-4">We've sent a 6-digit verification code to your registered email.</p>
        <InputText v-model="verificationCode" type="text" placeholder="Enter code" 
                   class="p-mb-4 p-inputtext-sm" style="width: 80%" />
        <Button label="Verify Code" @click="verifyCode" class="p-button-raised p-button-sm" />
        <small class="p-mt-3 p-text-secondary">
          Didn't receive code? 
          <a href="#" @click.prevent="resendCode" class="p-text-link">Resend</a>
        </small>
      </div>
    </Dialog>
    <Dialog header="Password Reset" :visible.sync="showResetDialog" :modal="true" 
    :style="{ width: '500px !important' }" @hide="resetForm">
      <div class="p-d-flex p-flex-column p-ai-center">
        <div v-if="resetStep === 1" class="p-fluid" style="width: 80%">
          <InputText v-model="resetEmail" type="email" placeholder="Email" class="p-mb-4" />
          <Button label="Send Code" @click="handleResetEmailSubmit" class="p-button-raised" />
        </div>
        
        <div v-else class="p-fluid" style="width: 80%">
          <InputText v-model="resetToken" placeholder="Reset Code" class="p-mb-3" />
          <Password v-model="resetPassword" placeholder="New Password" toggleMask class="p-mb-3" />
          <Password v-model="confirmPassword" placeholder="Confirm Password" toggleMask class="p-mb-4" />
          <Button label="Reset Password" @click="handleResetPasswordSubmit" class="p-button-raised p-mb-2" />
          <Button label="Back" @click="resetStep = 1" class="p-button-text" />
        </div>
      </div>
    </Dialog>

    <div class="fadeIn w-100">
      <div id="formContent" class="login-form">
        <div class="tabs">
          <h2 class="active">Sign In</h2>
          <router-link to="/inquiry"><h2 class="inactive">Inquiry</h2></router-link>
        </div>

        <div class="fadeIn first">
          <img src="static/img/eCalculo-Logo.png" alt="logo" class="logo-img" />
        </div>

        <form class="formInit">
          <input type="text" id="uname" class="fadeIn second" v-model="username" placeholder="Enter your username">
          <input type="password" id="password" class="fadeIn third" toggleMask v-model="password" placeholder="Enter your password">
          <Button label="Log In" @click.prevent="checkCreds" class="p-button-raised" />
          <div class="form-footer-links">
            <a href="#" @click.prevent="handleForgotPassword">Forgot Password?</a>
          </div>
        </form>

        <div id="formFooter">
          <span class="underlineHover">Powered by</span>
          <span> <a href="https://raisetech.com.np" target="_blank"><img src="static/img/raiseTechlogo.png"  alt="Raiselogo" class="img-fluid"/></a> </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import globalKey from '../store/globalKey'
import Toast from 'primevue/toast/Toast'
import Dialog from 'primevue/dialog'
import Password from 'primevue/password'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'Login',
  components: {
    Toast,
    Dialog,
    Password,
    InputText,
    Button
  },
  data() {
    return {
      section: 'Login',
      username: '',
      password: '',
      message: '',
      showCodeVerification: false,
      verificationCode: '',
      showResetDialog: false,
      resetStep: 1,
      resetEmail: '',
      resetToken: '',
      resetPassword: '',
      confirmPassword: '',
      failedAttempts: 0,
      loading: false
    }
  },
  methods: {
    async checkCreds() {
      const { username, password } = this
      const AUTH_URL = globalKey + '/auth'
      if (this.username.trim() === '' || this.password.trim() === '') {
        this.$toast.add({ severity: 'error', summary: '', detail: 'Username and Password cannot be empty!', life: 10000 })
        return
      }
      this.loading = true
      try {
        const response = await axios.post(AUTH_URL, { username, password })
        const data = response.data
        if (data.user) {
          this.$store.commit('SET_USER', data.user)
          const token = 'Bearer ' + data.access_token
          const organisationId = data.organisationId
          const fyId = data.fyId
          const startDate = data.startDate
          const expiry = data.expiry
          const modules = data.user.role.modules
          const englishDateExist = data.isEnglishDateEnabled
          const nepaliDate = data.nepaliNewDate
          const endDate = data.endDate
          const warehouse = data.warehouseId
          const counter = data.counterId
          const fyName = data.fyName
          const organisationAddress = data.organisationAddress
          const organisationName = data.organisationName
          const organisationContact = data.organisationContact
          const organisationLogo = data.organisationLogo
          const organisationPanVatNo = data.organisationPanVatNo
          const fiscalYear = data.fiscalYear
          const taxType = data.taxType
          const orgRemarks = data.orgRemarks
          const enable2FA = data.user.enable2FA
          const organisationIRDActive = data.IrdActive
          const irdUsername = data.IrdUsername
          const irdPassword = data.IrdPassword
          const ablePrintRealTime = data.ablePrintRealTime
          this.$store.commit('SET_TOKEN', token)
          this.$store.commit('ORGANISATIONID', organisationId)
          this.$store.commit('ENABLE2FA', enable2FA)
          this.$store.commit('IRDACTIVE', organisationIRDActive)
          this.$store.commit('IRDUSERNAME', irdUsername)
          this.$store.commit('IRDPASSWORD', irdPassword)
          this.$store.commit('orgRemarks', orgRemarks)
          this.$store.commit('FYID', fyId)
          this.$store.commit('STARTDATE', startDate)
          this.$store.commit('EXPIRY', expiry)
          this.$store.commit('MODULES', modules)
          this.$store.commit('ENGLISHDATEENABLED', englishDateExist)
          this.$store.commit('NEPALI_NEWDATE', nepaliDate)
          this.$store.commit('ENDDATE', endDate)
          this.$store.commit('SET_WAREHOUSE_DATA', warehouse)
          this.$store.commit('SET_COUNTER_DATA', counter)
          this.$store.commit('FYNAME', fyName)
          this.$store.commit('ORGANISATIONAME', organisationName)
          this.$store.commit('ORGANISATIONADDRESS', organisationAddress)
          this.$store.commit('ORGANISATIONCONTACT', organisationContact)
          this.$store.commit('ORGANISATIONLOGO', organisationLogo)
          this.$store.commit('ORGANISATIONPANVATNO', organisationPanVatNo)
          this.$store.commit('FISCALYEAR', fiscalYear)
          this.$store.commit('TAXTYPE', taxType)
          this.$store.commit('ablePrintRealTime', ablePrintRealTime)

          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(data.user))
            window.localStorage.setItem('token', token)
            window.localStorage.setItem('organisationId', organisationId)
            window.localStorage.setItem('enable2FA', enable2FA)
            window.localStorage.setItem('organisationIRDActive', organisationIRDActive)
            window.localStorage.setItem('irdUsername', irdUsername)
            window.localStorage.setItem('irdPassword', irdPassword)
            window.localStorage.setItem('fyId', fyId)
            window.localStorage.setItem('fiscalYear', fiscalYear)
            window.localStorage.setItem('startDate', startDate)
            window.localStorage.setItem('expiry', expiry)
            window.localStorage.setItem('modules', modules)
            window.localStorage.setItem('englishDate', englishDateExist)
            window.localStorage.setItem('nepaliNewDate', nepaliDate)
            window.localStorage.setItem('endDate', endDate)
            window.localStorage.setItem('getWarehouse', JSON.stringify(data.warehouseId))
            window.localStorage.setItem('getCounter', JSON.stringify(data.counterId))
            window.localStorage.setItem('fyName', fyName)
            window.localStorage.setItem('organisationName', organisationName)
            window.localStorage.setItem('organisationAddress', organisationAddress)
            window.localStorage.setItem('organisationContact', organisationContact)
            window.localStorage.setItem('organisationLogo', organisationLogo)
            window.localStorage.setItem('organisationPanVatNo', organisationPanVatNo)
            window.localStorage.setItem('taxType', taxType)
            window.localStorage.setItem('orgRemarks', orgRemarks)
            window.localStorage.setItem('ablePrintRealTime', ablePrintRealTime)
          }
          if (data.user.enableLoginTime) {
            const now = new Date()
            const [fromH, fromM, fromS] = data.loginAllowedFrom.split(':').map(Number)
            const [toH, toM, toS] = data.loginAllowedTo.split(':').map(Number)
            const loginFrom = new Date()
            loginFrom.setHours(fromH, fromM, fromS, 0)
            const loginTo = new Date()
            loginTo.setHours(toH, toM, toS, 0)
            if (now < loginFrom || now > loginTo) {
              this.$toast.add({severity: 'warn', summary: 'Login Restricted', detail: `You can login only between ${data.loginAllowedFrom} and ${data.loginAllowedTo}`, life: 10000})
              this.loading = false
              return
            }
          }
          if (data.user.enable2FA) {
            const response = await axios.post(`${globalKey}/passwordReset/initiate/${data.user.id}/${data.organisationId}`)
            if (response.data.status === 'ERROR') {
              this.$toast.add({severity: 'error', summary: 'Error', detail: response.data.message, life: 10000})
            }
            if (response.data.status === 'SUCCESS') {
              this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
            }
            this.showCodeVerification = true
          } else {
            this.$router.push('/dashboard')
          }
        }
      } catch (error) {
        this.failedAttempts++
        if (error.response.status === 401 && this.failedAttempts >= 4) {
          try {
            const userRes = await axios.get(`${globalKey}/users/findByUsername/${username}`)
            if (userRes.data.data) {
              await axios.post(
                `${globalKey}/users/login-activity/${userRes.data.data.id}/${userRes.data.data.organisationId.id}`
              )
              this.$toast.add({severity: 'warn', summary: 'Warning', detail: 'Suspicious login activity detected! Email notification sent.', life: 10000})
            //  this.showWarning('Suspicious login activity detected! Email notification sent.')
              return
            }
          } catch (err) {
            console.error('Error reporting activity:', err)
          }
        }
        this.handleLoginError(error)
      } finally {
        this.loading = false
      }
    },

    handleLoginError(error) {
      this.resetForm()
      if (error.response !== undefined) {
        if (error.response.status === 401) {
          window.localStorage.removeItem('token', this.token)
          this.$toast.add({severity: 'error', summary: 'Error', detail: 'Invalid Username or Password!', life: 10000})
          this.$router.push('/')
        }
      } else {
        window.localStorage.removeItem('token', this.token)
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Server appears to be offline. Please consult with our support Team.!', life: 10000})
      }
    },

    async verifyCode() {
      if (!this.verificationCode) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Please enter verification code', life: 10000})
        return
      }

      try {
        const orgID = this.$store.state.organisationid
        const response = await axios.post(
          `${globalKey}/passwordReset/codeVerify/${this.$store.state.user.id}/${orgID}`,
          { token: this.verificationCode }
        )
        if (response.data.status === 'ERROR') {
          this.$toast.add({severity: 'error', summary: 'Error', detail: response.data.message, life: 10000})
          return
        }
        if (response.data.status === 'SUCCESS') {
          this.resetForm()
          this.$router.push('/dashboard')
        }
      } catch (error) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Invalid or expired verification code', life: 10000})
      }
    },

    handleForgotPassword() {
      this.showResetDialog = true
      this.resetStep = 1
    },
    async resendCode() {
      try {
        const user = this.$store.state.user
        const orgID = this.$store.state.organisationid
        await axios.post(
          `${globalKey}/passwordReset/initiate/${user.id}/${orgID}`
        )
        this.showSuccess('New verification code sent to your email')
      } catch (error) {
        this.showError('Failed to resend verification code')
      }
    },
    async handleResetEmailSubmit() {
      if (!this.resetEmail) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Email is required', life: 10000})
        return
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.com$/i
      if (!emailPattern.test(this.resetEmail)) {
        this.$toast.add({severity: 'error', summary: 'Error', detail: 'Email must be a valid .com address', life: 10000})
        return
      }

      try {
        const response = await axios.post(`${globalKey}/passwordReset/initiate`, {
          email: this.resetEmail
        })
        if (response.data.status === 'ERROR') {
          this.showError(response.data.message)
          return
        }
        if (response.data.status === 'SUCCESS') {
          this.resetEmail = ''
          this.resetStep = 2
          this.showSuccess('Reset code sent to your email')
        }
      } catch (error) {
        this.showError('Failed to send reset code')
      }
    },

    async handleResetPasswordSubmit() {
      if (this.resetPassword !== this.confirmPassword) {
        this.showError('Passwords do not match')
        return
      }

      try {
        const response = await axios.put(`${globalKey}/passwordReset/confirm`, {
          token: this.resetToken,
          newPassword: this.resetPassword,
          confirmPassword: this.confirmPassword })

        if (response.data.status === 'ERROR') {
          this.showError(response.data.message)
          return
        }
        if (response.data.status === 'SUCCESS') {
          this.showSuccess('Password reset successfully')
          this.showResetDialog = false
          this.resetForm()
        }
      } catch (error) {
        this.showError('Failed to reset password')
      }
    },

    showError(message) {
      this.$toast.add({ severity: 'error', detail: message, life: 5000 })
    },
    showSuccess(message) {
      this.$toast.add({ severity: 'success', detail: message, life: 5000 })
    },
    showWarning(message) {
      this.$toast.add({ severity: 'warn', detail: message, life: 5000 })
    },
    resetForm() {
      this.verificationCode = ''
      this.resetEmail = ''
      this.resetToken = ''
      this.resetPassword = ''
      this.confirmPassword = ''
      this.showCodeVerification = false
      this.showResetDialog = false
      this.resetStep = 1
    }
  }
}
</script>

<style  scoped  src="@../../../static/css/loginpage.css">
.spinner {
    margin: 0 auto;
    height: 64px;
    width: 64px;
    animation: rotate 0.8s infinite linear;
    border: 5px solid #3c8dbc;
    border-right-color: transparent;
    border-radius: 50%;
}
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>



// WEBPACK FOOTER //
// Login.vue?26e76d9c